import { FC, PropsWithChildren, ComponentProps } from 'react';
import classNames from 'classnames';

export type FooterIconProps = PropsWithChildren<{
  href?: string;
  className?: string;
  icon: FC<ComponentProps<'svg'>>;
  ariaLabel?: string;
}>;

export const FooterIcon: FC<FooterIconProps> = ({ href, ariaLabel, className, icon: Icon }) => {
  return (
    <>
      {href ? (
        <a href={href} aria-label={ariaLabel} className={classNames('hover:text-black dark:hover:text-white', className)}>
          <Icon className="h-5 w-5" />
        </a>
      ) : (
        <Icon className="h-5 w-5" />
      )}
    </>
  );
};
